import { render, staticRenderFns } from "./view-brochures.vue?vue&type=template&id=23d93a14&"
import script from "./view-brochures.vue?vue&type=script&lang=js&"
export * from "./view-brochures.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports